<div class="appendices" *ngIf="showAppendices">
  <div *ngFor="let apendix of appendices">
    <span *ngIf="procedure?.status == 0"
      ><span [innerHTML]="apendix.text"></span
    ></span>
    <a
      *ngIf="procedure?.status != 0"
      [href]="apendix.file ? (apendix.file.id | fileLink) : apendix.url"
      [target]="opensInNewTab(apendix) ? '_blank' : '_self'"
      [rel]="opensInNewTab(apendix) ? 'noopener noreferrer' : null"
      >{{ apendix.text }}</a
    >
  </div>
</div>
